import { CategoryFromApi } from 'products/types'
import { getProductName } from 'products/productTable/utils'
import { TimeSlotGroup } from 'timeSlots/timeSlotsService'
import { V2AppliedGroup, V2ResolvedTimeSlots } from 'capacity/api/capacityV2Service'
import { FORM_SECTION } from 'capacity/copy'
import { GroupBlock } from './sectionModel'

export interface ServerBlocks {
    blocks: GroupBlock[]
    dependsOnCategory: boolean
    reason: V2ResolvedTimeSlots['reason']
}

const groupFromServer = (group: V2AppliedGroup): TimeSlotGroup => ({
    id: group.id,
    name: group.name ?? '',
    productsLists: [],
    article: null,
    weekdays: group.weekdays,
    availableFrom: group.availableFrom,
    availableTo: group.availableTo,
    timeSlots: group.slots.map((slot) => ({ startTime: slot.startTime, endTime: slot.endTime })),
    priority: null,
    visibilityOffsetMinutes: null,
    productsListNames: '',
    status: 'active',
})

const categoryName = (categories: CategoryFromApi[], id: string | null): string =>
    getProductName(categories.find((category) => category.id === id)?.name) || ''

const labelOf = (group: V2AppliedGroup, categories: CategoryFromApi[]): string => {
    switch (group.source) {
        case 'product':
            return FORM_SECTION.setOnProduct
        case 'category':
            return FORM_SECTION.fromCategory(categoryName(categories, group.categoryId))
        case 'parentCategory':
            return FORM_SECTION.fromParentCategory(categoryName(categories, group.categoryId))
        default:
            return FORM_SECTION.defaultForAll
    }
}

export function blocksFromServer(resolution: V2ResolvedTimeSlots, categories: CategoryFromApi[]): ServerBlocks {
    const blocks: GroupBlock[] = []
    for (const applied of resolution.groups) {
        const label = labelOf(applied, categories)
        const group = groupFromServer(applied)
        const existing = blocks.find((block) => block.label === label)
        if (existing) {
            if (!existing.groups.some((entry) => entry.id === group.id)) {
                existing.groups.push(group)
            }
        } else {
            blocks.push({ label, groups: [group] })
        }
    }
    return { blocks, dependsOnCategory: resolution.window === 'dependsOnCategory', reason: resolution.reason }
}
